export default __webpack_public_path__ + "static/media/5329.b7a2ab24.webp";